import { mixpanelEvents } from "config/servicesConfig/mixpanelEvents";

type Access = { id: string; accessGranted: boolean };

// Missing access on a new estate means sharing was never enabled, not an opt-out.
export async function saveEstateWithConsentTracking({
  previousAccess, nextAccess, segesOrgId, persist, track,
}: {
  previousAccess?: Access[];
  nextAccess?: Access[];
  segesOrgId: string;
  persist: () => Promise<string>;
  track: (event: string, properties: Record<string, unknown>) => Promise<unknown>;
}) {
  const isSharing = (access?: Access[]) =>
    access?.some((org) => org.id === segesOrgId && org.accessGranted) ?? false;
  const previousSharing = isSharing(previousAccess);
  const sharing = isSharing(nextAccess);
  const estateId = await persist();
  // Partial metadata updates (e.g. geocoding) do not change consent.
  if (nextAccess === undefined || previousSharing === sharing) return;
  try {
    await track(sharing ? mixpanelEvents.segesOptIn : mixpanelEvents.segesOptOut, {
      estateId, previousSharing, sharing,
    });
  } catch (error) {
    // Analytics failure must not turn a successful estate save into a failed save.
    console.error("Error tracking SEGES consent change", error);
  }
}
